<div class="cv-approve-modal-component" *ngIf="isOpen">
	<div class="cv-approve-box">
		<div class="modal-body">
			<p>
				There are unchecked rules or failed rules, are you sure you want to approve?
			</p>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-secondary"
				data-dismiss="modal"
				(click)="closeApproveBox()"
			>
				Cancel
			</button>
			<button 
				[disabled]="approving"
				type="button"
				class="btn btn-primary"
				(click)="approveOrder()"
			>
				Approve
			</button>
		</div>
	</div>
</div>
